import styled from 'vue-styled-components';

const hidRegions = ['Pakistan'];

export const MapPath = styled('path', { region: String })`
  &:hover {
    opacity: 0.8;
  }

  display: ${({ region }) => (hidRegions.includes(region) ? 'none' : 'block')};
`;
